import clsx from 'clsx'

interface SkeletonProps {
  className?: string
  variant?: 'text' | 'circle' | 'card' | 'row'
  lines?: number
}

export function Skeleton({ className, variant = 'text', lines = 1 }: SkeletonProps) {
  if (variant === 'circle') {
    return <div className={clsx('skeleton rounded-full', className)} />
  }

  if (variant === 'card') {
    return (
      <div className={clsx('card p-4 space-y-3', className)}>
        <div className="skeleton h-4 w-3/4 rounded" />
        <div className="skeleton h-3 w-1/2 rounded" />
        <div className="skeleton h-3 w-5/6 rounded" />
      </div>
    )
  }

  if (variant === 'row') {
    return (
      <div className={clsx('flex items-center gap-3 py-3', className)}>
        <div className="skeleton h-8 w-8 rounded-full shrink-0" />
        <div className="flex-1 space-y-1.5">
          <div className="skeleton h-3 w-2/3 rounded" />
          <div className="skeleton h-2.5 w-1/3 rounded" />
        </div>
      </div>
    )
  }

  return (
    <div className={clsx('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={clsx('skeleton h-3 rounded', i === lines - 1 ? 'w-2/3' : 'w-full')}
        />
      ))}
    </div>
  )
}

export function DashboardSkeleton() {
  return (
    <div className="space-y-8">
      <Skeleton variant="card" className="h-48" />
      <div className="flex gap-4 overflow-hidden">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} variant="card" className="h-40 w-72 shrink-0" />
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Skeleton variant="card" className="h-96" />
        <Skeleton variant="card" className="h-96" />
      </div>
    </div>
  )
}

export function TableSkeleton({ rows = 10 }: { rows?: number }) {
  return (
    <div className="space-y-1 p-4">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="row" />
      ))}
    </div>
  )
}
